import React, { Component, Fragment, useState } from 'react';
import autobind from 'autobind-decorator';
import classnames from 'classnames';
import update from 'immutability-helper';
import WindowEventHelper from '../../../../lib/WindowEventHelper';
import { isDescendant } from '../../../../lib/DomUtils';

class Calendar {
  static normalize (d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  constructor (current) {
    this.today = Calendar.normalize(new Date());
    this.limitDate = new Date(this.today.getFullYear() + 1, this.today.getMonth(), this.today.getDate());
    this.reset(current.getFullYear(), current.getMonth());
  }

  reset (year, month) {
    this.firstDate = new Date(year, month, 1);
    this.lastDate = new Date(year, month + 1, 0);
    this.hasPrev = this.today < this.firstDate;
    this.hasNext = this.limitDate > this.lastDate;

    this.year = this.firstDate.getFullYear();
    this.month = this.firstDate.getMonth();
  }

  canUse (d) {
    return (d >= this.firstDate && d >= this.today) &&
      (d <= this.lastDate && d <= this.limitDate);
  }

  isToday (d) {
    return d.getTime() === this.today.getTime();
  }

  createState () {
    return {
      firstDate: this.firstDate,
      lastDate: this.lastDate,
      hasPrev: this.hasPrev,
      hasNext: this.hasNext,
      year: this.year,
      month: this.month,
    };
  }
}

class CalendarForm extends Component {
  constructor (props) {
    super(props);
    const current = Calendar.normalize(props.selectedDate);
    this.calendar = new Calendar(current);
    this.state = update(this.calendar.createState(), {
      selectedDate: {
        $set: current,
      },
    });
    this.root = React.createRef();
  }

  static getDerivedStateFromProps (props, state) {
    const current = Calendar.normalize(props.selectedDate);
    if (state.selectedDate.getTime() !== current.getTime()) {
      return update(state, {
        selectedDate: {
          $set: current,
        },
      });
    } else {
      return state;
    }
  }

  componentDidMount () {
    WindowEventHelper.add('click', this.handleClose);
  }

  componentWillUnmount () {
    WindowEventHelper.remove('click', this.handleClose);
  }

  @autobind
  handleClose (e) {
    const { onClose } = this.props;
    if (!isDescendant(this.root.current, e.target)) {
      onClose(e);
    }
  }

  @autobind
  handleGoPrevMonth () {
    const { year, month } = this.state;
    const { calendar } = this;
    calendar.reset(year, month - 1);
    this.setState(calendar.createState());
  }

  @autobind
  handleGoNextMonth () {
    const { year, month } = this.state;
    const { calendar } = this;
    calendar.reset(year, month + 1);
    this.setState(calendar.createState());
  }

  render () {
    const { year, month, hasPrev, hasNext } = this.state;

    return (
      <div ref={this.root} className="layer_info" style={{ bottom: '40px', left: '9px' }}>
        <div className="inner_layer">
          <div className="box_calendar">
            <div className="info_date">
              <strong className="txt_calendar">{year}년 {month + 1}월</strong>
              <button type="button" className="btn_arr btn_prev" disabled={!hasPrev} onClick={this.handleGoPrevMonth}>
                <span className="mce-ico ico_prev">이전날짜</span>
              </button>
              <button type="button" className="btn_arr btn_next" disabled={!hasNext} onClick={this.handleGoNextMonth}>
                <span className="mce-ico ico_next">다음날짜</span>
              </button>
            </div>

            <div className="wrab_tbl">
              <table className="tbl_calendar">
                <caption className="ir_caption">일주일요일과 한달날짜</caption>
                <thead>
                  <tr>
                    <th scope="col">일</th>
                    <th scope="col">월</th>
                    <th scope="col">화</th>
                    <th scope="col">수</th>
                    <th scope="col">목</th>
                    <th scope="col">금</th>
                    <th scope="col">토</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderCalendar()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCalendar () {
    const { firstDate, lastDate } = this.state;
    const rendered = [];

    for (let i = -firstDate.getDay(); i < lastDate.getDate(); i += 7) {
      rendered.push(
        <tr key={`week${i}`}>
          {this.renderWeek(i)}
        </tr>
      );
    }
    return rendered;
  }

  renderWeek (startDay) {
    const { firstDate, lastDate, selectedDate } = this.state;
    const { onChange } = this.props;
    const { calendar } = this;
    const week = [];

    for (let i = startDay; i < startDay + 7; i++) {
      const current = new Date(firstDate.getTime());
      current.setDate(i + 1);

      week.push(
        <td key={`day${i}`} className={classnames({ present: calendar.isToday(current), selected: current.getTime() === selectedDate.getTime() })}>
          {(i >= 0 && current <= lastDate) &&
            <button type="button" className="btn_day" disabled={!calendar.canUse(current)} onClick={e => onChange(current.getFullYear(), current.getMonth(), current.getDate())}>
              {i + 1}
            </button>
          }
        </td>
      );
    }
    return week;
  }
}

export default CalendarForm;
